import { render, staticRenderFns } from "./CustomInputFloat.vue?vue&type=template&id=708c0825&"
import script from "./CustomInputFloat.vue?vue&type=script&lang=js&"
export * from "./CustomInputFloat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports